import mendeleev from "@/urls/mendeleev"
import {
  saveFileRequest,
  sendGetRequest
} from "@/helper/requests"

const state = {
  cards: {
    currentUrl: null,
    items: null,
    loading: false,
    error: null,
  }
}

const getters = {
  getCards: state => state.cards.items,
  getCardsDetail: state => state.cards.detail,
  isLoadingCards: state => state.cards.loading,
  saveCardsError: state => state.cards.error,
}

const actions = {
  loadCards: ({ commit, getters }, { finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.CARD.LIST()
    if (!getters.isLoadingCards) {
      commit('SET_CARDS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_CARDS', data)
          commit('SET_CARDS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_CARDS_LOADING_END')
          commit('SAVE_CARDS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  bindAppleWallet: ({ commit }, { url, card_id, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) url = url = mendeleev.USER.CARD.APPLE_WALLET(card_id)
    saveFileRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_CARDS_ERROR', data)
        catcher(data, url)
      }
    )
  },
  bindGoogleWallet: ({ commit }, { url, card_id, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) url = url = mendeleev.USER.CARD.GOOGLE_WALLET(card_id)
    sendGetRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_CARDS_ERROR', data)
        catcher(data, url)
      }
    )
  },
}

const mutations = {
  SET_CARDS: (state, value) => {
    state.cards.items = value
  },
  SET_CARDS_DETAIL: (state, value) => {
    state.cards.detail = value
  },
  SET_CARDS_LOADING: (state) => {
    state.cards.loading = true
  },
  SET_CARDS_LOADING_END: (state) => {
    state.cards.loading = false
  },
  SAVE_CARDS_ERROR: (state, error) => {
    state.cards.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
